import BaseAPI, { ROUTES, VERSIONS } from './BaseAPI'
import _ from 'lodash'

const { VERSION_TWO, VERSION_FIVE } = VERSIONS
const ROSTER_ENTITY_TYPES = [ 'user', 'distributionList' ]
const { CONVERSATION_FIND_ALL } = ROUTES

export default class RosterAPI extends BaseAPI {
  async findAll(options = { organizationId: null }) {
    const { version=VERSION_TWO } = super.getVersion(CONVERSATION_FIND_ALL)
    let markAsDelivered, orgId
    if (version === VERSION_FIVE) {
      markAsDelivered = 'true'
      orgId = options.organizationId
    }

    const query = { 'render_metadata': 'true', 'mark_as_delivered': markAsDelivered }
    if (orgId) {
      query.organization_id = orgId
    }

    const res = await this.httpClient.get('/:version/roster', {
      query,
      urlParams: { version }
    })

    return res.data
  }

  async add(counterPartyType: string, counterPartyId: string, organizationId: string) {
    if (!_.includes(ROSTER_ENTITY_TYPES, counterPartyType)) return

    const headers = {}

    if (organizationId) {
      headers['TT-X-Organization-Key'] = organizationId
    }

    const xmlnsType = this.__typeToNS(counterPartyType)

    await this.httpClient.post('/v2/roster', {
      headers,
      data: {
        entity: counterPartyId,
        type: xmlnsType
      }
    })
  }

  async remove(counterPartyType: string, counterPartyId: string, organizationId: string) {
    if (!_.includes(ROSTER_ENTITY_TYPES, counterPartyType)) return

    const headers = {}
    const xmlnsType = this.__typeToNS(counterPartyType)

    if (organizationId) {
      headers['TT-X-Organization-Key'] = organizationId
      headers['TT-X-Type'] = xmlnsType
    }

    await this.httpClient.del('/v2/roster/:counterPartyId', {
      headers,
      urlParams: { counterPartyId },
      data: {
        type: xmlnsType
      }
    })
  }

  __typeToNS(counterPartyType) {
    return COUNTER_PARTY_TYPE_TO_NS[counterPartyType]
  }
}

const COUNTER_PARTY_TYPE_TO_NS = {
  'user': 'tigertext:entity:account',
  'distributionList': 'tigertext:entity:list',
}
